export default {
  brand: {
    leninka: "Ленинка",
    artIp: "Арт IP",
    digitalEnv: "Цифровая платформа Российской государственной библиотеки",
    digitalEnvShort: "Цифровая платформа РГБ",
  },
  nav: {
    home: "Главная",
    profile: "Профиль",
    events: "Мероприятия",
    deposit: "Депонирование",
    admin: "Администрирование",
    contacts: "Контакты",
    about: "О нас",
    login: "Войти",
    loginMobile: "Войти / Профиль",
    logout: "Выйти",
    settings: "Настройки",
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    partnersGroup: "Логотипы партнёров проекта",
    ailaEcosystemAria: "AILA, экосистема РГБ",
    platformLabel: "Платформа",
    partnerAilaAlt: "AILA",
    partnerLeninkaArtAlt: "Логотип проекта «Ленинка Арт»",
    eventsMenuAria: "Меню раздела «Мероприятия»",
    eventsMenuPanelHeading: "Афиша и управление мероприятиями",
    eventsMenu: {
      all: "Все мероприятия",
      created: "Мои мероприятия",
      moderation: "Модерация мероприятий",
      registrations: "Модерация участников",
    },
  },
  footer: {
    portalTitle: "Экосистема",
    infoTitle: "Информация",
    aboutLibrary: "О нас",
    contacts: "Контакты",
    personalDataConsent: "Согласие на обработку персональных данных",
    personalDataProcessingPolicy: "Политика обработки персональных данных",
    tagline:
      "Помогаем творцам и командам развивать идеи, находить единомышленников и выстраивать индивидуальную траекторию роста",
    copyright: "© 2026 Российская государственная библиотека. Все права защищены.",
    terms: "Пользовательское соглашение",
    socialVk: "ВКонтакте",
    socialTelegram: "Telegram",
    socialOk: "Одноклассники",
    socialMax: "MAX",
    socialZen: "Дзен",
    socialLiveJournal: "LiveJournal",
    photoCreditsLead:
      "Фотоматериалы здания РГБ: Валерий Шустов, Сергей Пятаков (РИА Новости), Алексей Трошин, Paul Grach. Источник —",
    photoCreditsLicense: "CC BY-SA 3.0, CC BY 3.0, Public Domain",
  },
  common: {
    all: "Все",
    more: "Подробнее",
    openLink: "Открыть",
    register: "Зарегистрироваться",
    close: "Закрыть",
    cancel: "Отмена",
    searchCatalog: "Поиск по каталогу...",
    charLimit: "Превышен лимит символов",
    or: "или",
    loading: "Загрузка...",
    opensInNewTab: "откроется в новой вкладке",
    skipToContent: "Перейти к содержимому",
    pager: {
      navigation: "Пагинация",
      previousPage: "Предыдущая страница",
      nextPage: "Следующая страница",
    },
    datePicker: {
      prevMonth: "Предыдущий месяц",
      nextMonth: "Следующий месяц",
      clearDate: "Очистить дату",
      selectDay: "День",
      selectMonth: "Месяц",
      selectYear: "Год",
      selectPlaceholder: "—",
      calendarBirth: "Выбор даты рождения",
      calendarAchievement: "Выбор даты достижения",
      calendarWorkCreation: "Выбор даты создания произведения",
    },
    timePicker: {
      hours: "Часы",
      minutes: "Минуты",
    },
    table: {
      sortAria: "Сортировать: {{column}}, {{direction}}",
      sortDirectionAsc: "по возрастанию",
      sortDirectionDesc: "по убыванию",
      sortDirectionNone: "без сортировки",
    },
  },
  breadcrumbs: {
    home: "Главная",
    events: "Мероприятия",
    deposits: "Депонирование",
    details: "Детали",
  },
  home: {
    hero: {
      badge: "Ленинка",
      badgeAccent: "Арт IP",
      titleLine1: "Знания.",
      titleLine2: "Творчество.",
      titleLine3: "Будущее.",
      subtitle:
        "Помогаем творцам и командам развивать идеи, находить единомышленников и выстраивать индивидуальную траекторию роста",
      quickEvents: "Мероприятия",
      quickDeposit: "Депонирование",
      statYear: "форматов участия",
      statReaders: "активных пользователей",
      imageAlt: "Ленинская библиотека",
      scrollToQuickLinks: "Перейти к быстрым ссылкам",
    },
    directions: {
      kicker: "Что мы предлагаем",
      title1: "ОСНОВНЫЕ",
      title2: "НАПРАВЛЕНИЯ",
      eventsTitle: "Мероприятия",
      eventsDesc:
        "Лекции, выставки, мастер-классы и другие события экосистемы Ленинка IP для авторов, исследователей и креативных команд.",
      depositTitle: "Депонирование",
      depositDesc:
        "Официальная регистрация и защита авторских прав на ваши произведения в фондах РГБ.",
    },
    events: {
      kicker: "Афиша",
      title: "Мероприятия",
      allLink: "Все мероприятия",
      empty: "Ближайших мероприятий пока нет",
    },
    cta: {
      titleLine1: "Станьте частью сообщества",
      titleLine2: "",
      subtitle:
        "Регистрируйтесь, чтобы участвовать в событиях, развивать портфолио и использовать возможности платформы.",
      register: "Зарегистрироваться",
      imageAlt: "Присоединяйтесь",
    },
  },
  aboutPage: {
    documentTitle: "О РГБ",
    kicker: "Российская государственная библиотека",
    title: "О нас",
    lead:
      "Российская государственная библиотека — это не только книги и читальные залы. Это открытая экосистема знаний, культуры и технологий, где авторы, исследователи и креативные команды находят события, сохраняют свои произведения и развивают профессиональные связи.",
    childSiteTitle: "РГБ в цифровой среде",
    childSiteBody1:
      "Цифровые сервисы РГБ помогают работать с возможностями библиотеки онлайн: регистрироваться на мероприятия, депонировать произведения, подтверждать авторство и взаимодействовать с профессиональным сообществом. Портал дополняет офлайн-программы РГБ, перенося ключевые процессы в удобную цифровую среду.",
    missionTitle: "Миссия",
    missionText:
      "Сохраняем культурное наследие и развиваем пространство будущего, где знания, авторские работы, технологии и живые события соединяются в единую среду.",
    valuesTitle: "Ценности",
    values: {
      elite: "Сохранение и открытие знаний для новых поколений",
      trends: "Поддержка авторов через депонирование и цифровые сервисы",
      environment: "Создание среды для встреч, событий и специалистов будущего",
    },
    orgTeamTitle: "Руководство РГБ",
    orgTeamIntro:
      "Стратегическое развитие библиотеки, научно-издательское направление и образовательные программы курирует руководство Российской государственной библиотеки.",
    team: {
      director: "Вадим Дуда — генеральный директор",
      scientificPublishingDeputy:
        "Александр Самарин — заместитель генерального директора по научно-издательской деятельности",
      scientificEducationDirector:
        "Екатерина Дударева — директор Департамента научно-образовательной деятельности",
    },
    orgTeamCta: "Руководство на rsl.ru",
    expertCouncilTitle: "Экспертные и совещательные органы",
    expertCouncilIntro:
      "Экспертная работа РГБ опирается на официальные советы, положения и проектные органы библиотеки. Они помогают развивать научную, фондовую, цифровую и общественную повестку РГБ.",
    experts: {
      scientificCouncil: {
        name: "Учёный совет РГБ",
        role: "Научная экспертиза, развитие исследований и профессиональной повестки библиотеки",
      },
      bookMonumentsCouncil: {
        name: "Экспертный совет по книжным памятникам",
        role: "Экспертиза редких и ценных документов, связанных с книжным наследием",
      },
    },
    expertCouncilMore:
      "Официальные положения и документы о советах опубликованы в разделе документов РГБ.",
    expertCouncilCta: "Документы РГБ",
    ctaContacts: "Написать нам",
  },
  contactsPage: {
    kicker: "Связь с нами",
    title: "Контакты",
    writeUs: "Напишите нам",
    sentTitle: "Сообщение отправлено!",
    sentHint: "Мы ответим в течение 1–2 рабочих дней.",
    name: "Имя",
    email: "Email",
    subject: "Тема обращения",
    message: "Сообщение",
    send: "Отправить сообщение",
    address: "Адрес",
    phone: "Телефон",
    emailBlock: "Email",
    hours: "Часы работы",
    officialPages: "Официальные страницы",
    siteLabel: "Сайт АНО «ЛенинкаАрт»",
    socialNetworks: "Социальные сети",
    mapTitle: "Карта РГБ",
    subjects: {
      general: "Общий вопрос",
      events: "Мероприятия",
      deposit: "Депонирование",
      tech: "Технические вопросы",
      coop: "Сотрудничество",
    },
  },
  legalPages: {
    agreementTitle: "Пользовательское соглашение — Ленинка IP",
    personalTitle: "Согласие на обработку персональных данных — Ленинка IP",
    privacyTitle: "Политика обработки персональных данных — Ленинка IP",
  },
  notFound: {
    title: "Страница не найдена",
    hint: "Проверьте адрес или вернитесь на главную.",
    backHome: "На главную",
  },
}
